module.exports = __webpack_public_path__ + "img/60.474ff07b.jpg";